import {useCallback, useEffect} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getWorkspaceDetailsByIds} from 'src/openapi/admin/apis/UserWorkspacesApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    ids: (number)[],
    userId: number,
};

export const useGetWorkspacesDetails = ({ids, userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => {
        return apiDispatch(
            getWorkspaceDetailsByIds({userId, requestBody: ids}),
        );
    }, [ids, apiDispatch, userId]);

    const {data, isLoading, loadData, loadingError} = useReadOnlyDataHook({
        initValue: {},
        getDispatchAction,
        shouldLoadData: false,
    });

    useEffect(() => {
        if (ids.length) {
            loadData();
        }
    }, [ids, loadData]);

    return {data, isLoading, load: loadData, loadingError};
};
